import './src/styles/global.css';
import './node_modules/semantic-ui-css/semantic.min.css';
import { setRbSourceFromUTM } from './src/utils/sourceTracking';

export const onClientEntry = () => {
	setRbSourceFromUTM();
};
